import { Tiktok } from '@/components/Tiktok';
import { LabradorComponent } from '@/types/component';

export const LabradorTiktok: LabradorComponent = ({ type, data, meta }) => {
  return <Tiktok markup={data.oembed.html} data-content-index={meta.contentIndex} />;
};
